import type { ComponentType } from 'react';

import { isPPLFrontend } from './app-paths';

/**
 * Approach 1: Build-time HoC using `isPPLFrontend` flag
 * This creates a wrapper that conditionally renders the component based on build-time flags.
 * Only PPL tenants should see the component.
 */
export function withPPLGuard<T extends {}>(
  Component: ComponentType<T>,
  shouldDisplay: boolean = true,
): ComponentType<T> {
  return function PPLGuardedComponent(props: T) {
    // Use build-time flag for tree-shaking
    if (isPPLFrontend && shouldDisplay) {
      return <Component {...props} />;
    }

    return null;
  };
}
